import { createSelector } from 'reselect';
import { State } from 'flow/types/State';
import { featureFlagCheck } from 'flow/utils/feature-flag-utils';

export const selectFeatureFlags = (state: State) =>
    state.featureFlags.get('webClientFeatureFlags', []);

export const selectTransferInDoubleCallEnabled = createSelector(
    selectFeatureFlags,
    (featureFlags) =>
        !!featureFlagCheck(featureFlags, 'SHOW_TRANSFER_BUTTON_IN_DOUBLE_CALL'),
);

export const selectHasTicketsAdvancedSearch = createSelector(
    selectFeatureFlags,
    (featureFlags) =>
        !!featureFlagCheck(featureFlags, 'TICKETS_ADVANCED_SEARCH'),
);

export const selectHasTicketsSetAccessLevel = createSelector(
    selectFeatureFlags,
    (featureFlags) =>
        !!featureFlagCheck(featureFlags, 'TICKETS_SET_ACCESS_LEVEL'),
);

export const selectFaroObservabilityEnabled = createSelector(
    selectFeatureFlags,
    (featureFlags) => !!featureFlagCheck(featureFlags, 'FARO_OBSERVABILITY'),
);

export const selectHasThreads = createSelector(
    selectFeatureFlags,
    (featureFlags) => !!featureFlagCheck(featureFlags, 'THREADS'),
);
